import Vue from 'vue';
import App from './app';
import './registerServiceWorker';
import router from './router';
import store from './common/store';
import axios from 'axios';
import { extend, ValidationProvider } from 'vee-validate';
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import frag from 'vue-frag';
/* eslint-disable @typescript-eslint/camelcase */
import { is, max_value, required } from 'vee-validate/dist/rules';
import FlashMessage from '@/common/components/flash-message.component';
import HTTPClient from '@/common/http-client';
import { VueConfiguration } from 'vue/types/vue';
import Multiselect from 'vue-multiselect';
import AppConstants from './common/constants/app.constants';
// Google Tag Manager
import VueGtm from 'vue-gtm';

function init(config: VueConfiguration) {
  Vue.directive('frag', frag);

  Vue.config.productionTip = false;
  axios.defaults.baseURL = process.env.VUE_APP_API_URL;
  Vue.prototype.$axios = axios;
  Vue.component('ValidationProvider', ValidationProvider);
  Vue.component('Multiselect', Multiselect);

  // FlashMessageComponentを初期化します。
  const messageComponent = FlashMessage.getInstance(
    (msg: string) => store.dispatch('AlertMessageStore/addToSuccessMessageList', msg, { root: true }),
    (msg: string) => store.dispatch('AlertMessageStore/addToErrorMessageList', msg, { root: true }),
    () => store.dispatch('AlertMessageStore/removeAllErrorMessagesFromList', { root: true }),
    () => store.dispatch('AlertMessageStore/removeAllMessages', { root: true }),
    () => store.dispatch('AlertMessageStore/removeDisconnectMessage', { root: true })
  );

  // 成功とエラーのコールバックでHttpClientを初期化します。
  Vue.prototype.$axios = HTTPClient.getInstance(
    config,
    async (msg: string, delayedShowingMsg: boolean) => {
      await messageComponent.showSuccessMessage(msg, delayedShowingMsg);
    },
    async (msg: string, delayedShowingMsg: boolean) => {
      await messageComponent.showErrorMessage(msg, delayedShowingMsg);
    }
  ).HTTP;

  new Vue({
    router,
    store,
    created() {
      if (!navigator.onLine) {
        this.handleNetworkOffline();
      }

      // ネットワークがオンライン/オフラインの場合のエラー メッセージの表示/非表示。
      window.addEventListener('offline', () => {
        this.handleNetworkOffline();
      });
      window.addEventListener('online', () => {
        FlashMessage.getInstance().hideDisconnectMessage();
      });
    },
    destroyed() {
      window.removeEventListener('offline', () => {
        this.handleNetworkOffline();
      });
      window.removeEventListener('online', () => {
        FlashMessage.getInstance().hideDisconnectMessage();
      });
    },
    methods: {
      // ネットワークがオフラインの場合の処理。
      handleNetworkOffline() {
        this.$bvModal.hide(AppConstants.DETAIL_ERROR_MESSAGE_ID_MODAL);
        FlashMessage.getInstance().showNetworkOfflineMsg();
      }
    },
    render: (h) => h(App)
  }).$mount('#app');

  extend('required', {
    ...required,
    message: '{_field_}は必須です。'
  });
  extend('is', { ...is, message: '商品が違います。' });
  extend('max_value', { ...max_value, message: `残数以下にしてください。` });
}
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
Vue.prototype.$config = config;
init(Vue.prototype.$config);

// Google Tag Manager タグ埋め込み
Vue.use(VueGtm, {
  id: 'GTM-TPK3F72J'
});
